import { COLOR } from '@ordermentum/ui-constants/ui/color';
import { standard } from './standard';

export const flatState = {
  ...standard,
  height: {
    large: '3.5rem',
    medium: '3.1rem',
    default: '3.1rem',
  },
  tooltip: {
    bg: COLOR.BLACK,
    text: COLOR.WHITE,
  },
  error: {
    text: COLOR.GRAY_DEDEDE,
  },
  boxShadow: {
    active: 'none',
    inActive: 'none',
    error: 'none',
  },
  borderRadius: '6px',
  background: {
    active: COLOR.GRAY_FAFAFA,
    inActive: 'none',
    error: COLOR.GRAY_FAFAFA,
  },
  border: {
    active: `1px solid ${COLOR.GRAY_DEDEDE}`,
    inActive: 'none',
    error: `1px solid ${COLOR.GRAY_DEDEDE}`,
  },
  '&:disabled': {
    color: COLOR.BLACK,
  },
  color: {
    active: 'initial',
    inActive: COLOR.BLACK,
    error: 'initial',
  },
  cursor: {
    active: 'default',
    inActive: 'not-allowed',
    readOnly: 'text',
    error: 'default',
  },
  readOnly: {
    'pointer-events': 'auto',
    paddingLeft: 'inherit',
  },
  labelColor: {
    active: 'initial',
    inActive: COLOR.BLACK,
    error: 'initial',
  },
  hintColor: {
    active: 'initial',
    inActive: COLOR.BLACK,
    error: 'initial',
  },
  errorLabelColor: {
    error: COLOR.RED_500,
  },
};
